import { useState } from "react";

export const usePaginationState = (
  storageKey,
  defaultState = { pageSize: 10, page: 0 },
) => {
  const getInitialState = () => {
    try {
      const saved = sessionStorage.getItem(storageKey);
      return saved ? JSON.parse(saved) : defaultState;
    } catch {
      return defaultState;
    }
  };

  const [paginationModel, setPaginationModel] = useState(getInitialState);

  const handlePaginationModelChange = (newModel) => {
    setPaginationModel(newModel);
    sessionStorage.setItem(storageKey, JSON.stringify(newModel));
  };

  return [paginationModel, handlePaginationModelChange];
};
